import Layout from "../../../layout/Layout";
import React, { useEffect, useRef, useState } from "react";
import { Container } from "@mui/system";
import {
  Button,
  Checkbox,
  CircularProgress,
  Pagination,
  PaginationItem,
  Stack,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  ListItemButton,
  ListItemIcon,
  Select,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
  Autocomplete,
  Snackbar,
  Alert as MuiAlert,
  FormHelperText,
  Backdrop,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  config,
  statusAPI,
  userData,
  usersAPI,
  assetsAPI,
  ticketAPI,
} from "../../../config";
import axios from "axios";
import { TagsInput } from "../../../components/TagsInput";
import { Edit } from "@mui/icons-material";
// import TagsInput from "../../../components/TagsInput";
let type = 0,
  subType = 0,
  userIDOnchange = 0,
  assets1 = [];
export default function Assets() {
  const childRef = useRef(),
    [txtTodo, setTodo] = useState(""),
    [todoList, setTodoList] = useState([]),
    [isSubmitDisable, setIsSubmitDisable] = useState(false),
    [isDataLoading, setIsDataLoading] = useState(false),
    [checked, setChecked] = useState([0]),
    [totalCount, setTotalCount] = useState(0),
    [todoID, setTodoID] = useState(0),
    [issueTypeList, setIssueTypeList] = useState([]),
    [issueType, setIssueType] = useState(""),
    [issueSubType, setIssueSubType] = useState(""),
    [userID, setUserID] = useState(0),
    [issueSubTypeList, setIssueSubTypeList] = useState([]),
    [userList, setUserList] = useState([]),
    [assets, setAssets] = useState([]),
    [lstAssets, setLstAssets] = useState([]),
    [lstUserID, setListUserID] = useState(0),
    [selectedUser, setSelectedUser] = useState(null),
    [selectedType, setSelectedType] = useState(null);

  const limit = 5;

  const validationSchema = Yup.object().shape({
    // txtTodo: Yup.string()
    //   .required("To do description is required")
    //   .min(2, "Name must be at least 2 characters")
    //   .max(60, "Name cannot be more than 60 characters"),
  });

  const formOptions = {
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  };
  const { handleSubmit, formState, setValue } = useForm(formOptions);
  const { errors } = formState;

  let assetsRef = useRef(false);

  useEffect(() => {
    if (assetsRef.current === false) {
      assets1 = [];
      childRef.current.setData(assets1);

      let data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "1",
      });
      getStatus(data, "issueTypeList");

      data = JSON.stringify({
        intSubType: 0,
        txtAssets: "",
      });

      getUsers(data);

      return () => {
        assetsRef.current = true;
      };
    }
  }, []);

  const getStatus = (data, type) => {
    config.method = "PATCH";
    config.data = data;
    config.url = ticketAPI;

    axios(config)
      .then(function (response) {
        if (type === "issueTypeList") setIssueTypeList(response.data["data"]);
        else if (type === "issueSubTypeList")
          setIssueSubTypeList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const getUsers = (data) => {
    config.method = "PATCH";
    config.data = data;
    config.url = usersAPI;

    axios(config)
      .then(function (response) {
        setUserList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  //   FETCH ASSETS DATA START

  const fetchAssets = () => {
    const data = JSON.stringify({
      intUserID: userIDOnchange,
      txtAssets: "",
      intIssueSubType: subType,
    });

    config.method = "PATCH";
    config.data = data;
    config.url = assetsAPI;
    setIsDataLoading(true);
    axios(config)
      .then(function (response) {
        if (subType !== 0) {
          assets1 = [];
          if (response.data.data.length > 0) {
            assets1 = JSON.parse(response.data.data[0].assets);
          }
          childRef.current.setData(assets1);
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsDataLoading(false);
      });
  };

  // FETCH ASSETS DATA END

  // FETCH ASSETS DATA START

  const fetchUserAllAssets = () => {
    const data = JSON.stringify({
      intUserID: userIDOnchange,
      txtAssets: "",
      intIssueSubType: 0,
    });

    config.method = "PATCH";
    config.data = data;
    config.url = assetsAPI;
    setIsDataLoading(true);
    axios(config)
      .then(function (response) {
        // assets1 = [];
        // if (response.data.data.length > 0) {
        //   assets1 = JSON.parse(response.data.data[0].assets);
        // }
        // childRef.current.setData(assets1);

        setLstAssets(response.data.data);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsDataLoading(false);
      });
  };

  //   FETCH ASSETS DATA END

  // CHANGE TYPE START

  const handleIssueTypeChange = (e) => {
    setIssueType(e.target.value);
    const data = JSON.stringify({
      limit: 0,
      offset: 0,
      parent_id: e.target.value,
    });
    getStatus(data, "issueSubTypeList");
    type = e.target.value;
    fetchAssets();
  };

  // CHANGE TYPE START

  // INSERT TODO START

  const onSubmit = () => {
    // Flush any typed-but-not-Enter'd text and get the final list synchronously
    const currentAssets = childRef.current
      ? childRef.current.flushAndGetItems()
      : assets;

    const data = JSON.stringify({
      intUserID: userID,
      txtAssets: JSON.stringify(currentAssets),
      intIssueType: issueType,
      intIssueSubType: issueSubType,
    });

    config.method = "POST";
    config.data = data;
    config.url = assetsAPI;
    setIsDataLoading(true);
    axios(config)
      .then(function (response) {
        setTodoList(response.data.data);
        setIsDataLoading(false);
        setTotalCount(Math.round(response.data.count / limit));
        setTodoID(0);
        setTodo("");
        setValue("txtTodo", "");
        setOpen(true);
        setMessage(response.data.message);
        // Reset all form fields
        setIssueType("");
        setIssueSubType("");
        setIssueSubTypeList([]);
        setSelectedUser(null);
        setSelectedType(null);
        subType = 0;
        type = 0;
        setUserID(0);
        userIDOnchange = 0;
        assets1 = [];
        childRef.current.setData([]);
        fetchUserAllAssets();
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsDataLoading(false);
      });
  };

  // INSERT TODO END

  // TAG NAME START

  const handleSelectedTags = (items) => {
    setAssets(items);
  };

  // TAG NAME END

  // ISSUE SUB TYPE HANDLE CHANGE START

  const handleIssueSubTypeChange = (e) => {
    setIssueSubType(e.target.value);
    subType = e.target.value;
    fetchAssets();
  };

  // ISSUE SUB TYPE HANDLE CHANGE END

  const options = issueTypeList.map((option) => {
    // console.log(option, "option");
    const firstLetter = option.category;
    return {
      firstLetter: firstLetter,
      position: option.position,
      ...option,
    };
  });

  const [messageType, setMessageType] = React.useState("success");
  const [message, setMessage] = React.useState("");
  const [open, setOpen] = React.useState(false);

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Layout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isSubmitDisable}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Please wait...
        </Typography>
      </Backdrop>

      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={messageType}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>

      <Grid container spacing={5}>
        <Grid item lg={4} md={4} xs={12}>
          <div className={`white-bg`}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl className={`form-control`} fullWidth>
                {/* <InputLabel id="Type">Type</InputLabel>
                  <Select
                    labelId="Type"
                    id="demo-simple-select-helper"
                    value={issueType}
                    label="Type"
                    onChange={handleIssueTypeChange}
                    name="ddlType"
                  >
                    {issueTypeList.map((row, index) => (
                      <MenuItem value={row.id} key={index}>
                        {row.name}
                      </MenuItem>
                    ))}
                  </Select> */}

                <FormControl className={`form-control`} fullWidth>
                  <Autocomplete
                    id="combo-box-demo"
                    options={userList}
                    value={selectedUser}
                    getOptionLabel={(option) =>
                      option.username + " - " + option.email
                    }
                    fullWidth
                    renderInput={(params) => (
                      <TextField {...params} label="User" variant="outlined" />
                    )}
                    onChange={(event, newValue) => {
                      setSelectedUser(newValue);
                      userIDOnchange = 0;
                      if (newValue !== null) {
                        setUserID(newValue.id);
                        userIDOnchange = newValue.id;
                      } else {
                        setUserID(0);
                      }
                      fetchAssets();
                    }}
                  />
                </FormControl>

                <Autocomplete
                  id="grouped-demo"
                  options={options}
                  value={selectedType}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.name}
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} label="Type" />
                  )}
                  onChange={(event, newValue) => {
                    setSelectedType(newValue);
                    subType = 0;
                    if (newValue !== null) {
                      setIssueSubType(newValue.id);
                      subType = newValue.id;
                    } else {
                      setIssueSubType("");
                    }
                    fetchAssets();
                  }}
                />
              </FormControl>

              <FormControl className={`form-control`} fullWidth>
                <TagsInput
                  selectedTags={handleSelectedTags}
                  fullWidth
                  variant="outlined"
                  id="Assets"
                  name="Assets"
                  label="Assets"
                  tags={assets1}
                  ref={childRef}
                />
                <FormHelperText>*Press Enter to add an asset</FormHelperText>
              </FormControl>

              <FormControl className={`btn-section`}>
                <Button
                  size="large"
                  variant="outlined"
                  color="primary"
                  type="submit"
                  className={`btn-primary`}
                  disabled={isSubmitDisable}
                >
                  Submit
                </Button>
              </FormControl>
            </form>
          </div>
        </Grid>
        <Grid item lg={8} md={8} xs={12}>
          <div className={`white-bg`}>
            <FormControl className={`form-control`} fullWidth>
              <Autocomplete
                id="combo-box-demo"
                options={userList}
                getOptionLabel={(option) =>
                  option.username + " - " + option.email
                }
                fullWidth
                renderInput={(params) => (
                  <TextField {...params} label="User" variant="outlined" />
                )}
                onChange={(event, newValue) => {
                  userIDOnchange = 0;
                  if (newValue !== null) {
                    setListUserID(newValue.id);
                    userIDOnchange = newValue.id;
                  }
                  fetchUserAllAssets();
                }}
              />
            </FormControl>

            <div>
              {lstAssets.length === 0 ? (
                <Typography variant="h5">No Data Found</Typography>
              ) : (
                lstAssets.map((row, index) => {
                  const assetJson = JSON.parse(row.assets);
                  return assetJson.length === 0 ? (
                    <></>
                  ) : (
                    <div key={index} className={`box`}>
                      <Typography>{row.sub_type_name}</Typography>
                      <div>
                        {assetJson.map((row1, index1) => (
                          <div key={index1} className={`box1`}>
                            <Typography>{index1 + 1}.</Typography>
                            <Typography>{row1}</Typography>
                          </div>
                        ))}
                      </div>
                      {/* <div>
                        <Tooltip title="Edit">
                          <Edit />
                        </Tooltip>
                      </div> */}
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    </Layout>
  );
}
